/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ other: NonNullable<unknown> }} Irrigation_Schedule_Switch_HintInputs */

const vi_irrigation_schedule_switch_hint = /** @type {(inputs: Irrigation_Schedule_Switch_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lưu sẽ chuyển sang áp dụng lịch này và ngưng lịch ${i?.other}. Cấu hình lịch ${i?.other} vẫn được giữ.`)
};

/**

* @param {Irrigation_Schedule_Switch_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_switch_hint = /** @type {((inputs: Irrigation_Schedule_Switch_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Switch_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_switch_hint(inputs)
});